import React from 'react'
import styles from './index.css'

export default function Loading (props) {
  return (
    <div className={ styles.root }>
      <i className="icon-loading" />
    </div>
  )
}



/** WEBPACK FOOTER **
 ** ./src/components/Common/Loading/index.js
 **/